module.exports = __webpack_public_path__ + "static/media/Modal_Backing_9Slice.aca11a4a.png";